module.exports = __webpack_public_path__ + "img/pic2.3b8084e1.webp";